<template lang="pug">
.ok-cancel-modal
  b-modal(v-model="_value" :size="size" hide-header @ok="ok" no-close-on-backdrop no-close-on-esc)
    .default-modal-body
      .default-modal-title(:style="titleStyle") {{ title }}
      .default-modal-message(v-if="message" :style="messageStyle").mt-2 {{ message }}

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") {{ okButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### OKモーダル
 */
@Component
export default class OkModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** タイトル */
  @Prop()
  title!: string;
  /** タイトルのstyle */
  @Prop()
  titleStyle!: string;

  /** メッセージ */
  @Prop()
  message!: string;
  /** メッセージのstyle */
  @Prop()
  messageStyle!: string;

  /** モーダルサイズ */
  @Prop({ default: () => "md" })
  size!: string;

  /** OKボタンラベル */
  @Prop({ default: () => "閉じる" })
  okButtonLabel!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }
}
</script>
